// Carnet de lieux (transport, lot T1b-1) : types et recherche.
// Mêmes types que le serveur (backend/places.py : PLACE_KINDS).

export const PLACE_KINDS = {
  airport: "Aéroport", station: "Gare", hotel: "Hôtel", restaurant: "Restaurant",
  port: "Port", heliport: "Héliport", residence: "Résidence privée", other: "Autre",
};

// Texte comparable : sans accents, sans majuscules, espaces simples (« Hôtel  de Paris » = « hotel de paris »).
export const norm = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\s+/g, " ").trim();

// Même nom (casse et espaces ignorés), comme la règle « nom unique » du serveur.
export const sameName = (a, b) => (a || "").replace(/\s+/g, " ").trim().toLowerCase() === (b || "").replace(/\s+/g, " ").trim().toLowerCase();

// Lieux actifs dont le nom ou l'adresse contient tous les mots tapés (accents ignorés), dès 2 lettres.
// Les noms qui commencent par le texte tapé passent en premier.
export const searchPlaces = (places, text, limit = 8) => {
  const q = norm(text);
  if (q.length < 2) return [];
  const words = q.split(" ");
  return (places || [])
    .filter((p) => p.active !== false)
    .map((p) => ({ p, name: norm(p.name), all: norm(`${p.name} ${p.address}`) }))
    .filter((x) => words.every((w) => x.all.includes(w)))
    .sort((a, b) => (b.name.startsWith(q) - a.name.startsWith(q)) || (b.name.includes(q) - a.name.includes(q)) || a.name.localeCompare(b.name))
    .slice(0, limit)
    .map((x) => x.p);
};
